import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { find } from '@atlaskit/editor-common/quick-insert';
import { dedupe } from '@atlaskit/editor-common/utils';
export var getQuickInsertSuggestions = function getQuickInsertSuggestions(searchOptions) {
  var lazyDefaultItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return [];
  };
  var providedItems = arguments.length > 2 ? arguments[2] : undefined;
  // @ts-ignore
  var query = searchOptions.query,
    category = searchOptions.category,
    disableDefaultItems = searchOptions.disableDefaultItems,
    featuredItems = searchOptions.featuredItems,
    templateItems = searchOptions.templateItems,
    prioritySortingFn = searchOptions.prioritySortingFn;
  var defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
  var items = providedItems ? dedupe([].concat(_toConsumableArray(defaultItems), _toConsumableArray(providedItems)), function (item) {
    return item.title;
  }) : defaultItems;

  // For platform_editor_element_level_templates experiment only
  // clean up ticket ED-24873
  if (templateItems && featuredItems) {
    return items.filter(function (item) {
      var _item$id;
      return ['discussionNotes', 'approvalsTracker', 'decisionMatrix', 'actionList', 'instructionsOutline'].includes((_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : '') || item.featured;
    });
  }
  if (featuredItems) {
    return items.filter(function (item) {
      return item.featured;
    });
  }
  return find(query || '', category === 'all' || !category ? items : items.filter(function (item) {
    return item.categories && item.categories.includes(category);
  }), prioritySortingFn);
};